const ConnectToBinance = async (BscConnectProvider: any) => {
  try {
    const provider = new BscConnectProvider({
      supportedChainIds: [56, 97] // later on 1 ethereum mainnet and 3 ethereum ropsten will be supported
    });

    await provider.activate();

    return provider.getProvider();
  } catch (e) {
    console.log(e)
  }
};

export default ConnectToBinance;
